import _defineProperty from "@babel/runtime/helpers/defineProperty";
import _pick from "lodash/pick";

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

import { MigrationResult } from './migration-result';
export var migrateV0ToV1 = function migrateV0ToV1(data) {
  var baseData = _pick(data, ['title', 'xp', 'course_id', 'chapter_id', 'assignment', 'hint']);

  if (data.possible_answers.length === 1) {
    var possibleAnswer = data.possible_answers[0];
    var matchQuestion = /^(.*)\s+\[\[(.*)]\]$/.exec(possibleAnswer);

    if (matchQuestion === null) {
      throw new TypeError("Could not parse question. The single possible answer should have the following format: \"<solution> [[<question>]]\". Found: \"".concat(possibleAnswer, "\"."));
    }

    var parsedFeedbacks = data.feedbacks.map(function (line) {
      var matchFeedback = /^(?:(.*)\s+)?\[\[(.*)]\]$/.exec(line);

      if (matchFeedback === null) {
        throw new TypeError("Could not parse line in feedback: \"".concat(line, "\"."));
      }

      return {
        message: matchFeedback[2],
        pattern: matchFeedback[1] === undefined ? '.*' : matchFeedback[1]
      };
    });
    var firstFeedback = parsedFeedbacks.shift();

    if (firstFeedback === undefined) {
      throw new TypeError('There should be at least one feedback entry.');
    }

    return new MigrationResult('v1', _objectSpread(_objectSpread({}, baseData), {}, {
      question: {
        flavor: 'Open',
        items: [{
          feedback: parsedFeedbacks.map(function (_ref) {
            var message = _ref.message,
                pattern = _ref.pattern;
            return {
              message: message,
              pattern: pattern
            };
          }),
          question: matchQuestion[2],
          solution: {
            answer: matchQuestion[1],
            message: firstFeedback.message,
            pattern: firstFeedback.pattern
          }
        }]
      }
    }));
  }

  return new MigrationResult('v1', _objectSpread(_objectSpread({}, baseData), {}, {
    question: {
      feedback: data.feedbacks,
      flavor: 'PureMultipleChoice',
      possible_answers: data.possible_answers
    }
  }));
};
export var migrateV1ToV2 = function migrateV1ToV2(data) {
  var question = data.question.flavor === 'Open' ? {
    flavor: data.question.flavor,
    openQuestions: data.question.items
  } : data.question;
  return new MigrationResult('v2', _objectSpread(_objectSpread({}, data), {}, {
    question: question
  }));
};
export var migrateV2ToV3 = function migrateV2ToV3(data) {
  var instructionSteps = [];
  return new MigrationResult('v3', _objectSpread(_objectSpread({}, data), {}, {
    instructionSteps: instructionSteps
  }));
};
export var migrateV3ToV4 = function migrateV3ToV4(data) {
  return new MigrationResult('v4', _objectSpread({}, data));
};
export var migrateV4ToV5 = function migrateV4ToV5(data) {
  var fallbackAsset = null;
  return new MigrationResult('v5', _objectSpread(_objectSpread({}, data), {}, {
    fallbackAsset: fallbackAsset
  }));
};
export var migrations = {
  v0: migrateV0ToV1,
  v1: migrateV1ToV2,
  v2: migrateV2ToV3,
  v3: migrateV3ToV4,
  v4: migrateV4ToV5
};
export default migrations;